import * as React from "react";

const SvgDotSelected = (props) => (
  <svg
    width={34}
    height={34}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#dot-selected_svg__a)">
      <circle cx={17} cy={17} r={7} fill="currentColor" />
      <circle cx={17} cy={17} r={6.5} stroke="#fff" />
    </g>
    <defs>
      <filter
        id="dot-selected_svg__a"
        x={0}
        y={0}
        width={34}
        height={34}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1913_17247"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1913_17247"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgDotSelected;
